"use strict";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from "../../styles/clsx.js";
import classes from "./Card.module.css.js";
const Card = forwardRef(
  ({ className, spacing = "giga", as: Element = "div", ...props }, ref) => /* @__PURE__ */ jsx(
    Element,
    {
      ...props,
      ref,
      className: clsx(classes.base, classes[spacing], className)
    }
  )
);
Card.displayName = "Card";
export {
  Card
};
